<div [id]="modalType" class="d">
  <div class="overlay bg-black w-full h-full fixed top-0 left-0 opacity-50 z-50 text-4xl" (click)="closeModal(modalType)">
  </div>
  <div
    class="transition duration-700 ease-in-out fixed right-0 top-0  overflow-auto z-50 h-full bg-white shadow-xl modal" [class.delete-modal]="modalType === 'delete'"
    [class.pub_modal]="modalType === 'publish_unpublish'">
    <div class="m-4 fixed right-0 z-50 cursor-pointer">
      <div type="button" class="close text-gray cursor-pointer text-4xl" (click)="closeModal(modalType)">
        <span aria-hidden="true" class="close" title="Close">&times;</span>
      </div>
    </div>
    <div class="p-4 relative">

      <!-- Modal Body For creating New Variable  -->
      <div *ngIf="modalType === 'new_variable'">
        <h4 class="p-4 text-md font-medium">New variable name:</h4>
        <input class="input-style" type="text" id="varible_name">
      </div>
    </div>
    

      <!-- Modal Body For Delete  -->
      <div *ngIf="modalType === 'delete'">
        <h4 class="p-4 text-md font-light">Application {{ isAdmin? "Template" : ""}} <span
            class="text-md font-medium">"{{selectedApplication.applicationName}}"</span>will be deleted
          permanently.
        </h4>
        <p class="p-4 text-md font-medium greenish-blue">Are you sure?
        </p>
      </div>

      <div *ngIf="modalType === 'deleteDevice'">
        <h4 class="p-4 text-md font-light">
          <span
            class="text-md font-medium">"{{deleteSelectedDevice.deviceName}}"</span>
            device will be deleted permanently.
        </h4>
        <p class="p-4 text-md font-medium greenish-blue">Are you sure?
        </p>
      </div>

      <!-- Delete lab -->
      <div *ngIf="modalType === 'deleteLab'">
        <h4 class="p-4 text-md font-light">
          <span
            class="text-md font-medium">"{{deleteSelectedLab.labName}}"</span>
            lab will be deleted permanently.
        </h4>
        <p class="p-4 text-md font-medium greenish-blue">Are you sure?
        </p>
      </div>

      
      <!-- Modal for publish and unPublish  -->
      <div *ngIf="modalType === 'publish_unpublish'">
        <!-- Publish/Unpublish -->
        <form [formGroup]="publishForm">
          <app-loader *ngIf="isLoading"></app-loader>
          <div *ngIf="modalType === 'publish_unpublish'" class="flex flex-col">
            <div class="mb-2">
              <h4 class="text-lg font-semibold mar-left">Application Name: {{applicationName}} <span
                  style="font-size: small;">({{applicationIdentifier}})</span></h4>
            </div>
            <hr>
            <label class="mt-2 text-2xl font-bold mar-left">Application Type :</label>
            <div class="flex flex-row justify-center mt-4 div-width">
              <!-- Application Type Dropdown -->
              <div class="mr-4" style="margin-left: 15px;" *ngIf="org_type !== '' || modalType === 'publish_unpublish'">
                <!-- <select [ngClass]="applicationType ? 'outline':''" (focus)="onFocus()"
                  formControlName="applicationType">
                  <option value="">Select</option>
                  <option *ngFor="let option of dropdownOptions" [value]="option">{{ option }}</option>
                </select> -->
                <div class="flex justify-between mt-2">
                  <div class="flex flex-col">
                    <div>
                      <input formControlName="grok" id="GROK" type="checkbox"  (change)="onCheckBoxChange()" class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                      <label for="GROK" class="ml-2 text-xl">GROK</label>
                    </div>
    
                    <div class="mt-2">
                      <input formControlName="school" id="SCHOOL" (change)="onCheckBoxChange()" type="checkbox" class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                      <label for="SCHOOL" class="ml-2 text-xl">SCHOOL</label>
                    </div>
    
                    <div class="mt-2">
                      <input formControlName="college" id="COLLEGE" (change)="onCheckBoxChange()"  type="checkbox" class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                      <label for="COLLEGE" class="ml-2 text-xl">COLLEGE</label>
                    </div>
                    
                    <div class="mt-2">
                      <input formControlName="industry" id="INDUSTRY" (change)="onCheckBoxChange()" type="checkbox" class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                      <label for="INDUSTRY" class="ml-2 text-xl">INDUSTRY</label>
                    </div>
                  </div>
                  <div [ngClass]="!isExternallyCheckBoxVisible ? 'visible' :  ''" class="move-left">
                      <input formControlName="externally" id="externally" type="checkbox" class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                      <label for="externally" class="ml-2 text-xl">Is Externally</label>
                  </div>
                </div>
              </div>

              <!-- Published Dropdown -->
              <!-- <div class="org_dropdown" *ngIf="org_type !== '' || modalType === 'publish_unpublish'">
                <label class="mx-2 text-lg">Publish :</label>
                <select class="dropdown" formControlName="publish_id" style="border-radius: 0px;">
                  <option value="">Select</option>
                  <option *ngFor="let option of dropdownPublish" [value]="option">{{ option }}</option>
                </select>
              </div> -->
            </div>
            <!-- Hidden field for application identifier -->
            <input type="hidden" id="application_identifier" formControlName="applicationIdentifier">
          </div>
          <div class="p-4 flex justify-end">
            <!-- <button id="create-button" class="bg-greenish-blue text-white p-2 rounded-md shadow font-bold mr-2"
              type="button" (click)="updatePublish()" *ngIf="isUnpublish()">UNPUBLISH</button> -->
            <button id="cancel-button" class="text-gray-600 p-2 rounded-md font-bold mr-2" type="button"
              (click)="closeModal(modalType)">CANCEL</button>
            <button id="create-button" class="bg-greenish-blue text-white p-2 rounded-md shadow font-bold mr-2"
              type="button" (click)="updatePublish()">Submit</button>
          </div>
        </form>
      </div>

      <!-- Modal Action buttons  -->
      <div *ngIf="modalType !== 'publish_unpublish'"
        class="p-3 modalType !== 'associatedDevicesAlert' ? flex flex-row-reverse justify-center mb-2 : ''">
        <button *ngIf="!(modalType == 'associatedDevicesAlert' || modalType == 'devicesassociatedAlert')"
          class="bg-greenish-blue text-white p-2 rounded-md shadow font-bold mr-2" id="create-button"
          (click)="modalType === 'delete' || modalType === 'deleteDevice'  || modalType === 'deleteLab' ? deleteData($event):  closeModal(modalType)">{{
          modalType === 'delete' || modalType === 'deleteDevice' || modalType === 'deleteLab' ? "DELETE" : "CREATE"
          }}</button>
        <button
          class="modalType !== 'associatedDevicesAlert' ? flex flex-row-reverse justify-end : '' text-white bg-greenish-blue p-2 rounded-lg shadow-xl font-bold mr-2"
          type="button" (click)="closeModal(modalType)">CANCEL</button>
      </div>
    <!-- <div class="p-4 relative"  *ngIf="modalType === 'dialog'">
      <div >
        <h1 class="p-2 text-xl font-light text-center ">Are you going to Publish?</h1>
        <div>
          <div class="p-1 flex justify-center">
            <button class="bg-greenish-blue text-white p-2  rounded-md shadow font-bold mr-2 internally " (click)="changeInternallyPublishedFlag()">Internally</button>
          </div>
          <div class="text-center">
            <h1>or</h1>
          </div>
          <div class="p-1 flex justify-center">
            <button class="bg-greenish-blue text-white p-2 rounded-md shadow font-bold mr-2 all-users" (click)="changePublishedFlag()">To All Users</button>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="p-4">
      <button class="bg-button text-white p-2 rounded-md shadow font-bold mr-2" (click)="delete()">YES</button>
      <button class="text-gray-600 p-2 rounded-md font-bold mr-2" type="button"
        (click)="sidePanelClosed($event)">CANCEL</button>
    </div> -->

  </div>
</div>
